import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_instance_create = _resolveComponent("ontos-instance-create")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    ref: "base",
    "phone-flush": ""
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_ontos_instance_create, {
            key: 0,
            context: _ctx.$route.params,
            known: _ctx.known,
            "initial-values": _ctx.draft,
            "initial-name": _ctx.initialName,
            "create-next": "",
            autofocus: "",
            onSaved: _ctx.onSaved,
            onShowMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMessage', $event))),
            onShowErrorMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
          }, {
            controls: _withCtx(() => [
              _createVNode(_component_ontos_header_action, {
                icon: "mdi-view-list",
                label: _ctx.$tt('instance-list', {'collection-plural': _ctx.idea.pluralName}),
                to: {name: 'list-instances', params: _ctx.$route.params}
              }, null, 8, ["label", "to"])
            ]),
            _: 1
          }, 8, ["context", "known", "initial-values", "initial-name", "onSaved"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}